import { ErrorBoundary, Provider } from "@rollbar/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { PostHogProvider } from "posthog-js/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "./components/ui/toaster";
import { TooltipProvider } from "./components/ui/tooltip";
import "./index.css";
import DefaultErrorComponent from "./layouts/error";
import { AuthProvider } from "./providers/AuthProvider";
import { routeTree } from "./routeTree.gen";
import queryClient from "./utils/query-provider";
import posthog from 'posthog-js';

const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultErrorComponent: DefaultErrorComponent
});

const container = document.getElementById("root");

if (container === null) {
  throw new Error("app element does not exists.");
}

posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
  api_host: import.meta.env.VITE_POSTHOG_HOST,
  autocapture: true,
  capture_pageview: true,
  disable_session_recording: false,
  rageclick: true,
  capture_exceptions: {
    capture_console_errors: true,
    capture_unhandled_errors: true,
    capture_unhandled_rejections: true,
  },
  capture_heatmaps: {
    flush_interval_milliseconds: 5000,
  },
  capture_pageleave: true,
  capture_performance: {
    web_vitals: true
  },
  loaded: (posthog) => {
    if (import.meta.env.DEV) {
      posthog.opt_out_capturing();
    }
  }
});

createRoot(container).render(
  <StrictMode>
    <Provider
      config={{
        accessToken: "78bfb0f7d89e400487b49f4795130cfd",
        environment: process.env.NODE_ENV || "development",
        captureDeviceInfo: true,
        captureIp: true,
        captureUnhandledRejections: true,
        captureUncaught: true,
        enabled: process.env.NODE_ENV === "production",
        payload: {
          client: {
            javascript: {
              code_version: import.meta.env.VITE_APP_VERSION,
              source_map_enabled: true,
              guess_uncaught_frames: true
            }
          }
        }
      }}
    >
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <Toaster />
            <TooltipProvider>
              <PostHogProvider
                client={posthog}
              >
                <RouterProvider router={router} />
              </PostHogProvider>
            </TooltipProvider>
          </AuthProvider>
        </QueryClientProvider>
      </ErrorBoundary>
    </Provider>
  </StrictMode>
);
